import React from 'react';
import HostedAppDemo from '../components/HostedAppDemo';
import './MobileChatStage.css';

function MobileChatStage() {
  return (
    <section
      id="demo-chatbot"
      className="mobile-chat-stage is-revealed"
      aria-label="Live Virgil demo chat"
      data-dock-start=""
    >
      {/* The demo is a painting block like the art chapters, so its intro sits
          on the painting rather than floating on the page above it. */}
      <div className="mobile-chat-stage-sticky">
        <div className="mobile-chat-stage-background" aria-hidden="true" />
        <div className="mobile-chat-stage-veil" aria-hidden="true" />

        <div className="mobile-chat-stage-intro">
          <p className="mobile-section-eyebrow">
            <span className="mobile-chat-stage-live-dot" aria-hidden="true" />
            Live demo
          </p>
          <h2 className="mobile-section-title">Try the studio right here</h2>
          <p className="mobile-section-body">
            Ask for a scene, an image, or a storyboard frame and watch Virgil work.
          </p>
        </div>

        <div className="mobile-chat-stage-shell">
          <div className="mobile-chat-stage-app">
            <div className="mobile-chat-stage-chat-surface">
              <HostedAppDemo variant="mobile" showCopy={false} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MobileChatStage;
